import * as Yup from "yup";
import { getInitialValues } from "layouts/views/common/common";

const formField = {
  adjustmentNo: {
    name: "adjustmentNo",
    label: "Adjustment No",
    type: "text",
    editable: false,
    disabled: true, 
    maxLength: 20,
    xs: 3,
  },
  adjustmentDate: {
    type: "date",
    name: "adjustmentDate",
    label: "Adjustment Date",
    errorMsg: "Adjustment Date is required",
    required: true,
    xs: 3,
  },
  referenceNo: {
    type: "text", name: "referenceNo", label: "Reference No", maxLength: 20
  },
  ccBatchNo: {
    type: "text", name: "ccBatchNo", label: "CC Batch No", maxLength: 20, xs: 3,
  },
  remark: {
    type: "text", name: "remark", label: "Remark", maxLength: 300,
  },
  reasonCode: {
    type: "select",
    name: "reasonCode",
    label: "Adjustment Reason",
    errorMsg: "Adjustment Reason is required",
    required: true,
    xs: 3,
  },
  warehouseCode: {
    name: "warehouseCode",
    label: "Warehouse Code",
    type: "select",
    errorMsg: "Warehouse Code is required.",
    required: true,
    maxLength: 20,
    xs: 3,
  },
  customerCode: {
    type: "text",
    name: "customerCode",
    label: "Customer Code",
    errorMsg: "Customer Code is required",
    required: true,
    disabled: true,
    xs: 3,
  },
   divReq: {
    name: "divReq",
    label: "Division File Required",
    type: "switch",
    default: true,
    required: true,
  },
};

const { adjustmentNo, adjustmentDate, referenceNo, ccBatchNo, remark, reasonCode, warehouseCode, customerCode,divReq } = formField;

// export const formRender = [[adjustmentNo, adjustmentDate, referenceNo, ccBatchNo], 
// [customerCode, warehouseCode, reasonCode,divReq], 
// [remark]];

export const getFormRender = (showDivision) => [
  [adjustmentNo, adjustmentDate, referenceNo, ccBatchNo],
  [
    customerCode,
    warehouseCode,
    reasonCode,
    ...(showDivision ? [divReq] : [])
  ],
  [remark],
];

export const initialValues = getInitialValues(formField);

export const adjustmentValidation = Yup.object().shape({
  [adjustmentNo.name]: Yup.string().nullable().max(adjustmentNo.maxLength),
  [adjustmentDate.name]: Yup.date().nullable().required(adjustmentDate.errorMsg),
  [referenceNo.name]: Yup.string().nullable().max(referenceNo.maxLength),
  [ccBatchNo.name]: Yup.string().nullable().max(ccBatchNo.maxLength),
  [remark.name]: Yup.string().nullable().max(remark.maxLength),
  [reasonCode.name]: Yup.string().nullable().required(reasonCode.errorMsg),
  [warehouseCode.name]: Yup.string().nullable().max(warehouseCode.maxLength).required(warehouseCode.errorMsg),
  [customerCode.name]: Yup.string().nullable().required(customerCode.errorMsg),
});
